/**
 * Aviso de estado: error, conflicto, vacio o informacion.
 *
 * Un aviso de error se anuncia con `role="alert"` para que un lector de pantalla lo lea
 * en cuanto aparece; los informativos usan `role="status"`, que no interrumpe. El tono
 * **nunca** se transmite solo con color: siempre hay un titulo que dice que paso.
 */

export type TonoAviso = 'error' | 'aviso' | 'info';

interface PropiedadesAviso {
  readonly tono: TonoAviso;
  readonly titulo: string;
  readonly children?: React.ReactNode;
  readonly accion?: {
    readonly etiqueta: string;
    readonly alPulsar: () => void;
    readonly ocupado?: boolean;
  };
}

export function Aviso({ tono, titulo, children, accion }: PropiedadesAviso): React.JSX.Element {
  return (
    <div
      className={`aviso aviso--${tono}`}
      role={tono === 'error' ? 'alert' : 'status'}
      aria-live={tono === 'error' ? 'assertive' : 'polite'}
    >
      <p className="aviso__titulo">{titulo}</p>
      {children === undefined ? null : <div className="aviso__cuerpo">{children}</div>}
      {accion === undefined ? null : (
        <button
          className="boton boton--secundario"
          type="button"
          onClick={accion.alPulsar}
          disabled={accion.ocupado === true}
        >
          {accion.ocupado === true ? 'Reintentando…' : accion.etiqueta}
        </button>
      )}
    </div>
  );
}
